
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("babkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa3a871ee2099f32$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");

var $kSoKM = parcelRequire("kSoKM");
var $bWRlG = parcelRequire("bWRlG");

var $aFUXX = parcelRequire("aFUXX");

var $k1A8C = parcelRequire("k1A8C");

var $6R5uz = parcelRequire("6R5uz");

var $3gadb = parcelRequire("3gadb");

var $iu6m9 = parcelRequire("iu6m9");
var $0a8270c5d4be9683$exports = {};

var $fdmJU = parcelRequire("fdmJU");
/** Used to generate unique IDs. */ var $0a8270c5d4be9683$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $0a8270c5d4be9683$var$uniqueId(prefix) {
    var id = ++$0a8270c5d4be9683$var$idCounter;
    return $fdmJU(prefix) + id;
}
$0a8270c5d4be9683$exports = $0a8270c5d4be9683$var$uniqueId;



var $js7oX = parcelRequire("js7oX");

var $59U23 = parcelRequire("59U23");

var $9KIOh = parcelRequire("9KIOh");
const $fa3a871ee2099f32$var$titleStyles = (0, $3jLHL.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $aFUXX.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $fa3a871ee2099f32$var$containerStyles = (0, $3jLHL.css)({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, transparent)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 0.25rem)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $fa3a871ee2099f32$var$containerStylesExpanded = (0, $3jLHL.css)({
    background: "var(--ds-surface, rgba(255, 255, 255, 0.6))",
    paddingBottom: "var(--ds-space-100, 8px)",
    borderColor: "var(--ds-border, #091E4224)"
});
const $fa3a871ee2099f32$var$containerStylesFocused = (0, $3jLHL.css)({
    borderColor: "var(--ds-border-focused, #388BFF)"
});
const $fa3a871ee2099f32$var$containerStylesDataNodeTypeExpand = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $aFUXX.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $aFUXX.akLayoutGutterOffset)}px`
});
const $fa3a871ee2099f32$var$titleContainerStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #44546F)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $fa3a871ee2099f32$var$titleContainerStylesExpanded = (0, $3jLHL.css)({
    paddingBottom: "var(--ds-space-0, 0px)"
});
const $fa3a871ee2099f32$var$contentContainerStyles = (0, $3jLHL.css)({
    paddingTop: "var(--ds-space-0, 0px)",
    marginLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-200, 16px)",
    paddingLeft: "var(--ds-space-400, 32px)",
    display: 'flow-root',
    visibility: 'hidden',
    // The follow rules inside @supports block are added as a part of ED-8893
    // The fix is targeting mobile bridge on iOS 12 or below,
    // We should consider remove this fix when we no longer support iOS 12
    '@supports not (display: flow-root)': {
        width: '100%',
        boxSizing: 'border-box'
    }
});
const $fa3a871ee2099f32$var$contentContainerStylesExpanded = (0, $3jLHL.css)({
    paddingTop: "var(--ds-space-100, 8px)",
    visibility: 'visible'
});
const $fa3a871ee2099f32$var$contentContainerStylesNotExpanded = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.expand-content-wrapper, .nestedExpand-content-wrapper': {
        /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
        display: 'block',
        height: 0,
        overflow: 'hidden',
        clip: 'rect(1px, 1px, 1px, 1px)',
        userSelect: 'none'
    }
});
const $fa3a871ee2099f32$var$clearNextSiblingMarginTopStyle = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + *': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $fa3a871ee2099f32$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $fa3a871ee2099f32$var$containerStyles,
            props['data-node-type'] === 'expand' && $fa3a871ee2099f32$var$containerStylesDataNodeTypeExpand,
            props.expanded && $fa3a871ee2099f32$var$containerStylesExpanded,
            props.focused && $fa3a871ee2099f32$var$containerStylesFocused
        ],
        ...props
    }, props.children);
};
const $fa3a871ee2099f32$var$TitleContainer = (props)=>{
    const { expanded: expanded, ...buttonProps } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        type: "button",
        css: [
            $fa3a871ee2099f32$var$titleContainerStyles,
            expanded && $fa3a871ee2099f32$var$titleContainerStylesExpanded
        ],
        ...buttonProps
    }, props.children));
};
$fa3a871ee2099f32$var$TitleContainer.displayName = 'TitleContainerButton';
const $fa3a871ee2099f32$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $fa3a871ee2099f32$var$contentContainerStyles,
            props.expanded && $fa3a871ee2099f32$var$contentContainerStylesExpanded,
            !props.expanded && $fa3a871ee2099f32$var$contentContainerStylesNotExpanded
        ],
        ...props
    }, props.children);
};
function $fa3a871ee2099f32$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $d925B.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $59U23.PLATFORM).WEB,
            mode: (0, $59U23.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
}
function $fa3a871ee2099f32$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, nestedHeaderIds: nestedHeaderIds, rendererAppearance: rendererAppearance }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode);
    const { current: id } = (0, $gwFzn.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($0a8270c5d4be9683$exports)))('expand-title-'));
    const handleFocus = (0, $gwFzn.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $gwFzn.useCallback)(()=>setFocused(false), []);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($fa3a871ee2099f32$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9KIOh.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>setExpanded(true)
    }) : null, /*#__PURE__*/ (0, $3jLHL.jsx)($fa3a871ee2099f32$var$TitleContainer, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $fa3a871ee2099f32$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            setExpanded(!expanded);
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kSoKM.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k1A8C))),
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $kSoKM.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kSoKM.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k1A8C))),
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $fa3a871ee2099f32$var$titleStyles,
        id: id
    }, title || intl.formatMessage((0, $kSoKM.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $3jLHL.jsx)($fa3a871ee2099f32$var$ContentContainer, {
        expanded: expanded
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        className: `${nodeType}-content-wrapper`
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $fa3a871ee2099f32$var$clearNextSiblingMarginTopStyle
    }), (0, $iu6m9.editorExperiment)('confluence_p2m_style_recalc_and_expand_joint_exp', true, {
        exposure: true
    }) ? expanded && children : children))));
}
var $fa3a871ee2099f32$export$2e2bcd8739ae039 = (0, $js7oX.default)($fa3a871ee2099f32$var$Expand);

});


//# sourceMappingURL=Expand.7f0e0bf5.js.map
